import { useQuery } from "@tanstack/react-query"
import { AppRegistrationGet } from "../app/models/AppRegistration"
import { digitalManagerApi } from "../services/api"

export function useAppRegistrations() {
  const { data: appRegistrationsList = [], isLoading: isLoadingAppRegistrations } =
    useQuery({
      queryKey: ["appRegistrations"],
      queryFn: () =>
        digitalManagerApi
          .get<AppRegistrationGet[]>(`/appRegistrations`)
          .then((r) => r.data),
    })

  return {
    appRegistrationsList,
    isLoadingAppRegistrations,
  }
}
